var _rect, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperatorProfilePlaceholderSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 7,
    className: "bg"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0513,
    cy: 11.813,
    rx: 6.21144,
    ry: 6.21144,
    className: "fill stroke",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19924 26.663C8.19757 26.2263 8.29523 25.795 8.48482 25.4017C9.07979 24.2117 10.7576 23.5811 12.1498 23.2955C13.1539 23.0812 14.1718 22.9381 15.196 22.8671C17.0923 22.7005 18.9995 22.7005 20.8958 22.8671C21.9199 22.9389 22.9378 23.082 23.942 23.2955C25.3343 23.5811 27.0121 24.1522 27.607 25.4017C27.9883 26.2035 27.9883 27.1344 27.607 27.9362C27.0121 29.1857 25.3343 29.7568 23.942 30.0305C22.9391 30.2536 21.9208 30.4008 20.8958 30.4708C19.3524 30.6016 17.8018 30.6255 16.2551 30.5422C15.8981 30.5422 15.553 30.5422 15.196 30.4708C14.1748 30.4017 13.1604 30.2545 12.1617 30.0305C10.7576 29.7568 9.09169 29.1857 8.48482 27.9362C8.2962 27.5383 8.19864 27.1034 8.19924 26.663Z",
    className: "fill stroke",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorProfilePlaceholderSidebar);
export default __webpack_public_path__ + "static/media/operator-profile-placeholder-sidebar.d848a090fee6512d8e2c80c37b415057.svg";
export { ForwardRef as ReactComponent };